/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SurveyAnswer from './SurveyAnswer';

/**
 * The StudentSurveyAnswer model module.
 * @module model/StudentSurveyAnswer
 * @version 1.0.0
 */
class StudentSurveyAnswer {
    /**
     * Constructs a new <code>StudentSurveyAnswer</code>.
     * A student&#39;s answer to a survey question
     * @alias module:model/StudentSurveyAnswer
     */
    constructor() { 
        
        StudentSurveyAnswer.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentSurveyAnswer</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentSurveyAnswer} obj Optional instance to populate.
     * @return {module:model/StudentSurveyAnswer} The populated <code>StudentSurveyAnswer</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentSurveyAnswer();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('answer_id')) {
                obj['answer_id'] = ApiClient.convertToType(data['answer_id'], 'Number');
            }
            if (data.hasOwnProperty('specification')) {
                obj['specification'] = ApiClient.convertToType(data['specification'], 'String');
            }
            if (data.hasOwnProperty('answer')) {
                obj['answer'] = SurveyAnswer.constructFromObject(data['answer']);
            }
        }
        return obj;
    }


}

/**
 * Student answer identifier
 * @member {Number} id
 */
StudentSurveyAnswer.prototype['id'] = undefined;

/**
 * Selected answer identifier
 * @member {Number} answer_id
 */
StudentSurveyAnswer.prototype['answer_id'] = undefined;

/**
 * Additional specification provided by the student
 * @member {String} specification
 */
StudentSurveyAnswer.prototype['specification'] = undefined;

/**
 * @member {module:model/SurveyAnswer} answer
 */
StudentSurveyAnswer.prototype['answer'] = undefined;






export default StudentSurveyAnswer;

